import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import ExternalLawyerApplicationSection from "@/src/components/Sections/Jobs/ExternalLawyerApplicationSection";
import { Box, Typography } from "@mui/material";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird.tsx";
import { lpExternalLawyerStyle } from "@/src/containers/Pages/LpExternalLawyer/lpExternalLawyerStyle.ts";
import Grid from "@mui/material/Grid";
import Container from "@/src/components/Container/Container";
import LpExternalLawyerMeta from "@/src/containers/Pages/LpExternalLawyer/LpExternalLawyerMeta";
import { ArrowDownward } from "@mui/icons-material";

const advantages = [
  { title: "Flexibilität", subtitle: "Sie entscheiden, wann, von wo und wie viel Sie arbeiten." },
  { title: "Transparenz", subtitle: "Sie wissen immer, wie viel Sie pro Aufgabe verdienen." },
  { title: "Abwechslung", subtitle: "Schriftsätze, Fälle prüfen und vieles mehr." },
];

export default function LpExternalLawyer() {
  return (
    <LayoutPublicRoutes>
      <LpExternalLawyerMeta />
      <Container variant={"md"} sx={lpExternalLawyerStyle.titleContainer}>
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant={"h1"} sx={{ marginBottom: "1.5rem" }}>
              Legalbird Partneranwalt werden
            </Typography>
            <Typography
              sx={(theme) => ({
                marginBottom: "1rem",
                [theme.breakpoints.up("md")]: {
                  marginBottom: "3rem",
                },
              })}
            >
              Sie bringen Ihre Fähigkeiten, wir die Aufträge.
            </Typography>
            <LinkLegalbird to={"#bewerben"} standalone>
              Jetzt bewerben <ArrowDownward />
            </LinkLegalbird>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            {advantages.map(({ title, subtitle }) => {
              return (
                <Box sx={lpExternalLawyerStyle.advantage} key={title}>
                  <Typography component={"h2"} variant={"h4"}>
                    {title}
                  </Typography>
                  <Typography
                    component={"div"}
                    variant={"h6"}
                    sx={(theme) => ({
                      color: theme.palette.text.secondary,
                    })}
                  >
                    {subtitle}
                  </Typography>
                </Box>
              );
            })}
          </Grid>
        </Grid>
      </Container>
      <Box sx={lpExternalLawyerStyle.applicationSectionContainer}>
        <ExternalLawyerApplicationSection />
      </Box>
    </LayoutPublicRoutes>
  );
}
